import React, { useState } from "react";
import SidebarCom from "../../component/SidebarCom/SidebarCom";
import { Route, Routes } from "react-router-dom";
import TopbarCom from "../../component/TopbarCom/TopbarCom";
import {
  admin_sidebar_route,
  vendor_sidebar_route,
} from "../../utils/routelist";
import { useSelector } from "react-redux";

const MainScreen = () => {
  const { user } = useSelector((state) => state.userAuth);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const roleManageRoute =
    user?.role === "Admin" ? admin_sidebar_route : vendor_sidebar_route;

  return (
    <div>
      <div className="flex min-h-screen bg-gray-100 overflow-y-hidden">
        <SidebarCom
          isMobileMenuOpen={isMobileMenuOpen}
          closeMobileMenu={() => setIsMobileMenuOpen(false)}
        />

        <div className="flex-1 flex flex-col relative">
          <TopbarCom
            onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          />

          {/* Overlay for mobile */}
          {isMobileMenuOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
              onClick={() => setIsMobileMenuOpen(false)}
            />
          )}

          <div className="p-6 h-[calc(100vh-60px)] overflow-y-auto">
            <Routes>
              {roleManageRoute.map((elem, index) => (
                <Route key={index} path={elem.path} element={elem.element} />
              ))}
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainScreen;
